import TYPES from '../../types';

// Domain
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

type Address = {
  street: string;
  external_number: string;
  interior_number: string;
  postal_code: string;
  settlement: {
    codPais: string;
    descPais: string;
    codEstado: string;
    descEstado: string;
    codLocalidad: string;
    codMunicipio: string;
    codigoPostal: string;
    descLocalidad: string;
    descMunicipio: string;
  };
  municipality: {
    codPais: string;
    codEstado: string;
    codMunicipio: string;
    descMunicipio: string;
  };
  state: {
    codestado: string;
    descestado: string;
    codpais: string;
  };
  country: {
    descpais: string;
    codpais: string;
  };
}

@Injectable()
export default class AddressService {
  @Inject(TYPES.CUSTOMER_ADDRESS_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  setAddressData(address: Address): void {
    this.state_manager.state.address = { ...address };
  }

  getAddressData(): Address {
    return this.state_manager.state.address;
  }
}
